import React, { useEffect, useState } from "react";
import { notification } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../../controllers/V1/raffleWinners/raffleWinnersController";

import ImageUploader from "../../../components/ImageUploader/ImgUploader";
import { ASSETS_BASE_URL } from "../../../config/constants";
import moment from 'moment';
const PromocodeEditPage = () => {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(state || []);

  const [showUploader, setShowUploader] =useState(false);
  const toggleImgUploader = () => setShowUploader(!showUploader);
  const [ imageUrl, setImageUrl ] = useState(state?.image || '');

  // const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    setAddEditData((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };
 
  

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);

      const params = {
        ...(form.get("edit_id") && { editId: form.get("edit_id") }),
        order_no    : form.get("order_no"),
        draw_date   : form.get("draw_date"),
        title       : form.get("title"),
        coupon_code : form.get("coupon_code"),
        name        : form.get("name"),
        mobile      : form.get("mobile"),
        prize       : form.get("prize"),
        image       : imageUrl || '',
      };
      const isValidate = await validateFormData(params);
      if (isValidate === true) {
        const res = await addEditData(params);
        console.log(res, "res__-");
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/raffle-winners/list");
        } else {
          notification.open({
            message: "Oops!.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        // console.log('validation error',error);
        // notification.open({
        //   message: "Oops!",
        //   description: `Validation Error.`,
        //   placement: "topRight",
        //   icon: <InfoCircleOutlined style={{ color: "red" }} />,
        //   duration: 2,
        // });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const { order_no, draw_date, coupon_code, title, name, mobile, prize, image } = formData;

      let status = false;
      let msg = "noError";
      let error_field = "noError";
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!order_no) {
        error_field = "order_no";
        msg = "Order number is required.";
        status = false;
      } else if (!draw_date) {
        error_field = "draw_date";
        msg = "Draw date is required.";
        status = false;
      } else if (!coupon_code) {
        error_field = "coupon_code";
        msg = "Coupon code is required.";
        status = false;
      } else if (!title) {
        error_field = "title";
        msg = "Title is required";
        status = false;
      } else if (!name) {
        error_field = "name";
        msg = "Name is required";
        status = false;
      } else if (!mobile) {
        error_field = "mobile";
        msg = "Mobile is required";
        status = false;
      } else if (!prize) {
        error_field = "prize";
        msg = "Prize is required";
        status = false;
      } else if (!image) {
        error_field = "image";
        msg = "Image is required";
        status = false;
      } else {
        status = true;
      }

      if (!status && setError) {
        setError((prevError) => ({
          ...prevError,
          [error_field]: msg,
        }));
        notification.open({
          message: "Oops!",
          description: `${msg}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }

      return status;
    } catch (error) {
      console.log("error", error);
      return false;
    }
  };

  useEffect(() => {
    document.title = `Crown King || ${
      ADDEDITDATA?._id ? "Edit" : "Add"
    } Winner`;
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading">
              {" "}
              {ADDEDITDATA?._id ? `Edit` : `Add`} Raffle Winner{" "}
            </h5>
          </React.Fragment>
          <Link to={"/raffle-winners/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary">
                {" "}
                <ArrowLeftOutlined /> Back{" "}
              </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form
                method="post"
                className="inventory_form_main_contnet"
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="edit_id" id="edit_id" value={ADDEDITDATA._id || ""} />

                <div className="row">
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="order_no" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Order Number :{" "}
                    </label>
                    <input title="Order Number" placeholder="Order Number" type="text" name="order_no" className={`form-control store_input_field ${error.order_no && ( 'error' )}`} id="order_no" value={ADDEDITDATA?.order_no} onChange={handleChange} />
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="draw_date" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Draw Date :{" "}
                    </label>
                    <input title="Draw Date" placeholder="Draw Date" type="date" name="draw_date" className={`form-control store_input_field ${error.draw_date && ( 'error' )}`} id="draw_date" value={moment(ADDEDITDATA?.draw_date).format('YYYY-MM-DD')} onChange={handleChange} />
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="coupon_code" className="all_section_for_label_main_class" > <span style={{ color: "red" }}>*</span>Coupon code :</label> <input
                      title="Coupon code" placeholder="Coupon code" type="text" name="coupon_code" className={`form-control store_input_field ${error.coupon_code && ( 'error' )}`}
                       id="coupon_code" value={ADDEDITDATA?.coupon_code} onChange={handleChange} />
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="title" className="all_section_for_label_main_class" > <span style={{ color: "red" }}>*</span>Title :{" "}  </label>
                    <input
                      title="Title"
                      placeholder="Title"
                      type="text"
                      name="title"
                      className={`form-control store_input_field ${error.title && ( 'error' )}`}
                      id="title"
                      value={ADDEDITDATA?.title}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="name" className="all_section_for_label_main_class" > Winner's Name:
                    </label>
                    <input
                      title="Winner's Name"
                      placeholder="Winner's Name"
                      type="text"
                      name="name"
                      className={`form-control store_input_field ${error.name && ( 'error' )}`}
                      id="name"
                      value={ADDEDITDATA?.name}
                      onChange={handleChange}
                    />
                  </div>
                  {/* New Fields for Valid From and Expire Date */}
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="mobile" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Winner's Mobile :
                    </label>
                    <input
                      title="Winner's Mobile"
                      placeholder="Winner's Mobile"
                      type="number"
                      name="mobile"
                      className={`form-control store_input_field ${error.mobile && ( 'error' )}`}
                      id="mobile"
                      value={ADDEDITDATA?.mobile}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="prize" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Prize :
                    </label>
                    <input
                      title="Prize"
                      placeholder="Prize"
                      type="text"
                      name="prize"
                      className={`form-control store_input_field ${error.prize && ( 'error' )}`}
                      id="prize"
                      value={ADDEDITDATA?.prize}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="image" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Image :
                    </label>
                    <input type="hidden" value={imageUrl} name="image" id="image"/>
                    <button type="button" className="form-control store_input_field btn btn-primary inventory_save_button" onClick={toggleImgUploader}>Select image</button>
                    {imageUrl && (
                      <span>
                        <img src={`${ASSETS_BASE_URL}${imageUrl}`} width={'100px'}/>
                      </span>
                    )}
                  </div>

                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="submit"
                    className="btn btn-primary inventory_save_button"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ImageUploader openUpload={showUploader} toggleUploadOpen={toggleImgUploader} setImgUrl={setImageUrl} />
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default PromocodeEditPage;
